import {
  Directive,
  inject,
  ElementRef,
  Renderer2,
  input,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MetadataViewService } from '../core/view-states/metadata-view.service.js';
import { filter, map, switchMap } from 'rxjs/operators';
import { CasinoSettingKeyId } from '@gains-com/shared';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hideOnCasinoSettingDisabled]',
  standalone: true,
})
export class HideOnCasinoSettingDisabledDirective {
  readonly settingKey = input.required<CasinoSettingKeyId | keyof typeof CasinoSettingKeyId>({
    alias: 'hideOnCasinoSettingDisabled',
  });

  private readonly _metadataView = inject(MetadataViewService);
  private readonly _el = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);

  constructor() {
    toObservable(this.settingKey)
      .pipe(
        map(raw => (CasinoSettingKeyId[raw as keyof typeof CasinoSettingKeyId] ?? raw) as CasinoSettingKeyId),
        filter(Boolean),
        switchMap(key => this._metadataView.casinoSettingValue$<boolean>(key)),
        takeUntilDestroyed(),
      )
      .subscribe((enabled) => {
        // Hide element if setting is false, show if true
        if (enabled === false) {
          this._renderer.setStyle(this._el.nativeElement, 'display', 'none');
        } else if (enabled === true) {
          this._renderer.removeStyle(this._el.nativeElement, 'display');
        }
        // If undefined/null (loading), keep current state
      });
  }
}
